/**
 *  @class
 *  @function Cart
 */
class Cart {

  constructor() {
    this.container = document.getElementById('Cart');
    this.setupEventListeners();
    this.updatePlusButtonStates();
  }
  onChange(event) {
    if (event.target.type == 'number') {
      const input = event.target;
      const newQty = parseInt(input.value);
      const inventory = parseInt(input.dataset.inventory);
      const inventoryManagement = input.dataset.inventoryManagement;
      const inventoryPolicy = input.dataset.inventoryPolicy;
      const line = input.dataset.index;
      
      // If inventory is tracked and overselling not allowed, check against inventory
      if (inventoryManagement === 'shopify' && inventoryPolicy === 'deny' && !isNaN(inventory)) {
        if (newQty > inventory) {
          this.displayErrors(line, `Only ${inventory} available`);
          // Reset input to max available
          input.value = inventory;
          // Auto-hide error after 3 seconds
          setTimeout(() => {
            this.clearErrors(line);
          }, 3000);
          return;
        }
      }
      
      this.updateQuantity(line, input.value);
    } else if (event.target.getAttribute('id') == 'CartSpecialInstructions') {
      this.saveNotes();
    }
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('CartSpecialInstructions').value
      })
    });
  }
  setupEventListeners() {
    this.removeProductEvent();

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener('cart:refresh', (event) => {
      this.refresh();
    });

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.termsCheckbox();
  }
  getSectionsToRender() {
    return [{
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  displayErrors(line, message) {
    // Always remove loading state first, regardless of whether error element exists
    const cartItem = this.container.querySelector(`#CartItem-${line}`);
    if (cartItem) {
      cartItem.classList.remove('loading');
    }
    
    // Clean up the error message - make it more user friendly
    let cleanMessage = message;
    if (message && message.toLowerCase().includes('all') && message.toLowerCase().includes('stock')) {
      // Extract quantity from message like "All 1 Example Product are in your cart."
      const match = message.match(/all\s+(\d+)/i);
      if (match) {
        cleanMessage = `Only ${match[1]} available`;
      } else {
        cleanMessage = 'Max quantity in cart';
      }
    }
    
    // Show error message in mobile error element
    const lineItemErrorMobile = document.getElementById(`Line-item-error-${line}`);
    if (lineItemErrorMobile) {
      lineItemErrorMobile.removeAttribute('hidden');
      lineItemErrorMobile.querySelector('.cart-item__error-text').innerHTML = cleanMessage;
    }
    
    // Show error message in desktop error element
    const lineItemErrorDesktop = document.getElementById(`Line-item-error-desktop-${line}`);
    if (lineItemErrorDesktop) {
      lineItemErrorDesktop.removeAttribute('hidden');
      lineItemErrorDesktop.querySelector('.cart-item__error-text').innerHTML = cleanMessage;
    }
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  clearErrors(line) {
    // Hide mobile error element
    const lineItemErrorMobile = document.getElementById(`Line-item-error-${line}`);
    if (lineItemErrorMobile) {
      lineItemErrorMobile.setAttribute('hidden', '');
    }
    
    // Hide desktop error element
    const lineItemErrorDesktop = document.getElementById(`Line-item-error-desktop-${line}`);
    if (lineItemErrorDesktop) {
      lineItemErrorDesktop.setAttribute('hidden', '');
    }
  }
  updatePlusButtonStates() {
    // Find all quantity inputs and update their plus button states
    const inputs = this.container.querySelectorAll('input.qty[data-inventory]');
    inputs.forEach(input => {
      const currentQty = parseInt(input.value);
      const inventory = parseInt(input.dataset.inventory);
      const inventoryManagement = input.dataset.inventoryManagement;
      const inventoryPolicy = input.dataset.inventoryPolicy;
      
      // Find the plus button in the same quantity-selector
      const quantitySelector = input.closest('quantity-selector');
      if (quantitySelector) {
        const plusButton = quantitySelector.querySelector('.plus');
        if (plusButton) {
          if (inventoryManagement === 'shopify' && inventoryPolicy === 'deny' && !isNaN(inventory)) {
            if (currentQty >= inventory) {
              plusButton.classList.add('disabled-max');
            } else {
              plusButton.classList.remove('disabled-max');
            }
          }
        }
      }
    });
  }
  async updateQuantity(line, quantity) {
    this.container.classList.add('cart-disabled');
    if (line) {
      this.container.querySelector(`#CartItem-${line}`).classList.add('loading');
      this.clearErrors(line);
    }

    try {
      const cartResponse = await fetch(`${theme.routes.cart_url}.js`);
      const cart = await cartResponse.json();

      const updatedItem = cart.items[line - 1];
      const bundleId = updatedItem.properties?._racquet_bundle_id;
      
      // Check if the updated item is a RACQUET (has Stringing property)
      const isRacquet = updatedItem.properties && 
        (updatedItem.properties.Stringing === 'Hybrid' || 
         updatedItem.properties.Stringing === 'Strung');

      // Handle RACQUET Removal/Reduction - remove all companion items with same bundle ID
      if (isRacquet && bundleId && parseInt(quantity) < updatedItem.quantity) {
        // Find ALL companion items that share this specific bundle ID
        const associatedCompanions = cart.items.filter(item => {
          return item.properties?._racquet_bundle_id === bundleId && 
                 cart.items.indexOf(item) !== (line - 1); // Exclude the racquet itself
        });

        if (associatedCompanions.length > 0) {
          const updates = cart.items.map(item => item.quantity);
          const quantityReduction = updatedItem.quantity - parseInt(quantity);
          
          // Update the racquet quantity
          updates[line - 1] = parseInt(quantity);
          
          // Update all companion items (string, tension, labor stringing)
          associatedCompanions.forEach(companion => {
            const companionIndex = cart.items.indexOf(companion);
            if (quantity === '0') {
              // If removing racquet completely, remove all its companions
              updates[companionIndex] = 0;
            } else {
              // Reduce companion quantity by same amount as racquet reduction
              updates[companionIndex] = Math.max(0, companion.quantity - quantityReduction);
            }
          });

          const response = await fetch(`${theme.routes.cart_update_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              updates: updates
            })
          });

          const parsedState = await response.json();
          
          // Check for errors in the response
          if (parsedState.errors) {
            this.displayErrors(line, parsedState.errors);
            this.container.classList.remove('cart-disabled');
            return;
          }
          
          const sectionsResponse = await fetch(`${window.location.pathname}?sections=${this.getSectionsToRender().map((section) => section.section).join(',')}`);
          const sectionsState = await sectionsResponse.json();

          this.renderContents(sectionsState, line, true);
          this.container.classList.remove('cart-disabled');
          return;
        }
      }
      
      // Normal update for all other cases (non-bundle items, quantity increases, etc.)
      const response = await fetch(`${theme.routes.cart_change_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        })
      });

      const parsedState = await response.json();

      // Check for errors - Shopify returns 422 status and error messages when quantity exceeds stock
      if (!response.ok || parsedState.errors || parsedState.message || parsedState.description) {
        const errorMessage = parsedState.errors || parsedState.message || parsedState.description || 'Unable to update quantity';
        this.displayErrors(line, errorMessage);
        
        // Wait 1.5 seconds so customer can read the error, then refresh cart to get corrected quantities
        await new Promise(resolve => setTimeout(resolve, 1500));
        
        const sectionsResponse = await fetch(`${window.location.pathname}?sections=${this.getSectionsToRender().map((section) => section.section).join(',')}`);
        const sectionsState = await sectionsResponse.json();
        this.renderContents(sectionsState, line, true);
        
        // Re-display error after render (since renderContents replaces the HTML)
        this.displayErrors(line, errorMessage);
        
        this.container.classList.remove('cart-disabled');
        return;
      }

      this.renderContents(parsedState, line, false);
      this.container.classList.remove('cart-disabled');

    } catch (error) {
      console.error('Error:', error);
      // Always remove loading state on error
      if (line) {
        const cartItem = this.container.querySelector(`#CartItem-${line}`);
        if (cartItem) {
          cartItem.classList.remove('loading');
        }
      }
      this.container.classList.remove('cart-disabled');
    }
  }
  refresh() {
    this.container.classList.add('cart-disabled');

    let sections = this.getSectionsToRender().map((section) => section.section).join(',');

    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);


        if (parsedState.errors) {
          this.displayErrors(line, parsedState.errors);
          this.container.classList.remove('cart-disabled');
          return;
        }

        this.renderContents(parsedState, false, true);

        this.container.classList.remove('cart-disabled');
        
        // Update custom header cart count
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const allCounts = document.querySelectorAll('.te-header-icon__count');
            allCounts.forEach(el => {
              el.textContent = cart.item_count;
            });
          })
          .catch(err => console.error('Error fetching cart count:', err));
      });
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartTerms'),
      checkout_button = this.container.querySelector('.button.checkout-button');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
      });
    });
  }
  renderContents(parsedState, line, refresh) {
    this.getSectionsToRender().forEach((section => {
      const sectionElement = document.getElementById(section.id);
      if (!sectionElement) return; // Skip if element doesn't exist
      
      const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;

      if (refresh) {
        if (parsedState[section.section]) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        }
      } else {
        if (parsedState.sections && parsedState.sections[section.section]) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }
      }
    }));

    this.removeProductEvent();

    if (line && this.container.querySelector(`#CartItem-${line}`)) {
      this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
    }
    this.termsCheckbox();
    this.updatePlusButtonStates();

    // Update custom header cart count (te-header-icon__count) by fetching cart
    setTimeout(() => {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const allCounts = document.querySelectorAll('.te-header-icon__count');
          allCounts.forEach(el => {
            el.textContent = cart.item_count;
          });
        })
        .catch(err => console.error('Error fetching cart count:', err));
    }, 100);
  }
}window.addEventListener('load', () => {
  if (typeof Cart !== 'undefined') {
    new Cart();
  }
});